export enum TempUnit {
  CELCIUS,
  FAHRENHEIT,
}

export function kelvinToCelcius(num: number) {
  return Math.round(num - 273.15);
}

export function celciusToFahrenheit(c: number) {
  return Math.round(c * (9 / 5) + 32);
}

export function fahrenheitToCelcius(f: number) {
  return Math.round(((f - 32) * 5) / 9);
}

export function kmToMile(n: number) {
  return Math.round(n / 1.60934);
}

export function mileToKm(n: number) {
  return Math.round(n * 1.60934);
}
